<router-outlet></router-outlet>
<div class="global-loader" *ngIf="loginIsInProgress">
    <h1>LOADING</h1>
</div>